import { Link } from 'react-router-dom';
import { Shield, Cookie, FileText, Mail, Heart } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-gray-900 text-gray-400">
      {/* Main Footer */}
      <div className="max-w-6xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <h3 className="text-xl font-bold text-white mb-4 tracking-wide">REVELIAE</h3>
            <p className="text-sm leading-relaxed">
              Votre portail ésotérique personnel. Numérologie, astrologie, tarot et chiromancie 
              propulsés par l'intelligence artificielle.
            </p>
          </div>
          
          {/* Applications */}
          <div>
            <h4 className="text-white font-semibold mb-4">Applications</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/lumina" className="hover:text-white transition-colors">LUMINA (Chiromancie)</Link></li>
              <li><Link to="/numerologia" className="hover:text-white transition-colors">NUMEROLOGIA</Link></li>
              <li><Link to="/astrozodiac" className="hover:text-white transition-colors">ASTROZODIAC</Link></li>
              <li><Link to="/mysteriae" className="hover:text-white transition-colors">MYSTERIAE (Tarot)</Link></li>
            </ul>
          </div>
          
          {/* Account */}
          <div>
            <h4 className="text-white font-semibold mb-4">Mon compte</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/auth" className="hover:text-white transition-colors">Connexion / Inscription</Link></li>
              <li><Link to="/profile" className="hover:text-white transition-colors">Mon profil</Link></li>
              <li><Link to="/premium" className="hover:text-white transition-colors">Offres Premium</Link></li>
            </ul>
          </div>
          
          {/* Legal */}
          <div>
            <h4 className="text-white font-semibold mb-4">Informations légales</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/legal/privacy" className="hover:text-white transition-colors flex items-center gap-2">
                  <Shield className="h-4 w-4" />
                  Politique de confidentialité
                </Link>
              </li>
              <li>
                <Link to="/legal/cookies" className="hover:text-white transition-colors flex items-center gap-2">
                  <Cookie className="h-4 w-4" />
                  Politique de cookies
                </Link>
              </li>
              <li>
                <Link to="/legal/terms" className="hover:text-white transition-colors flex items-center gap-2">
                  <FileText className="h-4 w-4" />
                  Conditions générales de vente
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      
      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="max-w-6xl mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-sm">
              © {currentYear} REVELIAE. Tous droits réservés.
            </p>
            <div className="flex items-center gap-6 text-sm">
              <a href="mailto:contact@reveliae.com" className="hover:text-white transition-colors flex items-center gap-2">
                <Mail className="h-4 w-4" />
                contact@reveliae.com
              </a>
              <span className="flex items-center gap-1">
                Fait avec <Heart className="h-4 w-4 text-rose-500" /> en France
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
